import classNames from 'classnames';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { RichText } from '@preventx/prismic-services';
import { List, ListItem, OrderedListStyle } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

export type OrderedListProps = SliceComponentProps<Content.OrderedListSlice>;

const OrderedList = ({ slice }: OrderedListProps) => {
  const { id, primary } = slice;
  const { content_type, list_type, secondary_layer, tertiary_layer } = primary;

  const style = {
    Default: undefined,
    'Bullet Point': undefined,
    Alphabetic: 'list-style-type-upper-alpha' satisfies OrderedListStyle,
    'Roman Numerals': 'list-style-type-upper-roman' satisfies OrderedListStyle,
  }[list_type] as OrderedListStyle;

  const contentType = content_type === 'Compliance' ? 'compliance' : 'default';

  const { WebsiteUrl } = applicationEnv();

  return (
    <List
      style={style}
      component="ol"
      className={classNames({
        'ct-list': content_type === 'Compliance',
      })}
    >
      {primary.list_items.map((first, index) => {
        const secondLayer = secondary_layer.filter(
          (layer) => layer.list_item_group_id === first.group_by_id,
        );

        const style = {
          Default: undefined,
          'Bullet Point': undefined,
          Alphabetic: 'list-style-type-upper-alpha' satisfies OrderedListStyle,
          'Roman Numerals':
            'list-style-type-upper-roman' satisfies OrderedListStyle,
        }[first.list_type] as OrderedListStyle;

        return (
          <ListItem key={`ol-layer-one-${id}-${index + 1}`}>
            <RichText
              variant={contentType}
              content={first.content}
              websiteUrl={WebsiteUrl}
            />

            {secondLayer.length > 0 && (
              <List component="ul" style={style}>
                {secondLayer.map((second) => {
                  const thirdLayer = (tertiary_layer ?? []).filter(
                    (layer) =>
                      layer.secondary_list_group_id ===
                      second.secondary_list_group_id,
                  );

                  return (
                    <ListItem key={`ol-layer-two-${id}-${index + 1}`}>
                      <RichText
                        variant={contentType}
                        content={second.content}
                        websiteUrl={WebsiteUrl}
                      />

                      {thirdLayer.length > 0 && (
                        <List component="ul" style={style}>
                          {thirdLayer.map((third) => (
                            <ListItem key={`ol-layer-three-${id}-${index + 1}`}>
                              <RichText
                                variant={contentType}
                                content={third.content}
                                websiteUrl={WebsiteUrl}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </ListItem>
                  );
                })}
              </List>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

export default OrderedList;
